<template>
    <div>
        <v-row class="white pl-3 pr-3 ml-0 mr-0">
            <v-col cols="2">
                <az-text-view
                    label="Tipo Ajuste"
                    :text="ajuste.tipo | textoSemValorSimples"/>
            </v-col>
            <v-col cols="8">
                <az-text-view
                    label="Observações"
                    :text="ajuste.observacao | textoSemValorSimples"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'AjusteDetalheCampos',
        props: ['ajuste']
    }
</script>
